module.exports = __webpack_public_path__ + "img/band_logo.3a5c30a7.png";